import Icon from '../icon/Icon'
import s from './style.module.scss'

interface IPrefix {
  icon?: string
}

function Prefix({ icon }: IPrefix) {
  return icon ? (
    <span className={s.prefix}>
      <Icon name={icon} mui />
    </span>
  ) : (
    <span />
  )
}

export default Prefix
